import { useTranslation } from '@infield/features/i18n';
import { createContext } from 'react';

import { SchedulesWeekPickerUi } from './schedules-week-picker-ui';
import { getNextWeekDates, getPreviousWeekDates } from './utils';

export interface SchedulesWeekPickerContextInterface {
  getPreviousWeekDates: typeof getPreviousWeekDates;
  getNextWeekDates: typeof getNextWeekDates;
  SchedulesWeekPickerUi: typeof SchedulesWeekPickerUi;
}

export const defaultValue: SchedulesWeekPickerContextInterface = {
  getPreviousWeekDates,
  getNextWeekDates,
  SchedulesWeekPickerUi,
};

export const SchedulesWeekPickerContext =
  createContext<SchedulesWeekPickerContextInterface>(defaultValue);
